import { Trans } from '@lingui/macro'
import { TableDataContainer } from 'components/Table'
import { PAGE_SIZE } from 'graphql/data/TopTokens'
import { GridContainer, NoTokensStateM } from 'pages/Liquidity/Table'

import { LoadedRow, LoadingRow } from './LiquidationRow-m'

const LoadingRows = ({ rowCount }: { rowCount: number }) => (
  <>
    {Array(rowCount)
      .fill(null)
      .map((_, index) => {
        return <LoadingRow key={index} first={index === 0} last={index === rowCount - 1} />
      })}
  </>
)

function LoadingTokenTable({ rowCount = PAGE_SIZE }: { rowCount?: number }) {
  return (
    <GridContainer>
      <TableDataContainer>
        <LoadingRows rowCount={rowCount} />
      </TableDataContainer>
    </GridContainer>
  )
}

export default function TableM({ token01, resData }: { token01: boolean; resData: any }) {
  /* loading and error state */
  if (!resData) {
    return <LoadingTokenTable rowCount={5} />
  } else if (resData?.length === 0) {
    return <NoTokensStateM message={<Trans>No liquidationList found</Trans>} />
  } else {
    return (
      <>
        <TableDataContainer>
          {resData?.map((liquidation: any, index: any) => (
            <LoadedRow
              token01={token01}
              key={index}
              liquidationListIndex={index}
              liquidationListLength={resData.length}
              liquidation={liquidation}
            />
          ))}
        </TableDataContainer>
      </>
    )
  }
}
